/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { useReactiveVar } from '@apollo/client';
import * as React from 'react';
import { dataExportModalProps } from '../../../../apollo/reactiveVariables/UIVariables';
import { ConfirmationModal } from '../../../components/DataExport/ConfirmationModal';
import { CreationModal } from '../CreationModal';
import { ViewResultModal } from '../ViewResultModal';

export enum DataExportModalType {
    Confirmation = 'Confirmation',
    Creation = 'Creation',
    ViewResult = 'ViewResult',
}

export interface DataExportModalProps {
    isOpen: boolean;
    modalType?: DataExportModalType;
    modalProps?: any;
}

// This is the global modal component that created at ApprovalsApp component.
// And then we can use the useSetDataExportModal hook to open the modal and select the modal type we want.
export const DataExportModal: React.FC = (): JSX.Element => {
    const { isOpen, modalType, modalProps } = useReactiveVar(dataExportModalProps);

    return modalType === DataExportModalType.Confirmation ? (
        <ConfirmationModal isOpen={isOpen} {...modalProps} />
    ) : modalType === DataExportModalType.Creation ? (
        <CreationModal isOpen={isOpen} />
    ) : modalType === DataExportModalType.ViewResult ? (
        <ViewResultModal isOpen={isOpen} {...modalProps} />
    ) : null;
};
